import React from "react";
import PropTypes from "prop-types";

function SearchLogo({className = ""}) {
  return (

<svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <g clip-path="url(#clip0_6489_2593)">
    <path d="M15.0258 13.8476L18.595 17.4159L17.4158 18.5951L13.8475 15.0259C12.5197 16.0903 10.8683 16.6692 9.16663 16.6667C5.02663 16.6667 1.66663 13.3067 1.66663 9.16675C1.66663 5.02675 5.02663 1.66675 9.16663 1.66675C13.3066 1.66675 16.6666 5.02675 16.6666 9.16675C16.669 10.8684 16.0901 12.5199 15.0258 13.8476ZM13.3541 13.2292C14.4117 12.1417 15.0023 10.6838 15 9.16675C15 5.94341 12.3891 3.33341 9.16663 3.33341C5.94329 3.33341 3.33329 5.94341 3.33329 9.16675C3.33329 12.3892 5.94329 15.0001 9.16663 15.0001C10.6837 15.0025 12.1415 14.4118 13.2291 13.3542L13.3541 13.2292Z" fill="#0E0E0E"/>
  </g>
  <defs>
    <clipPath id="clip0_6489_2593">
      <rect width="20" height="20" fill="white"/>
    </clipPath>
  </defs>
</svg>
  );
}

SearchLogo.propTypes = {
  className: PropTypes.string,
};

export default SearchLogo;






